"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyRegimeEnum = void 0;
/**
 * Potentially applicable data privacy legal regimes
 * NOTE: Please make sure that new entries are compatible with GraphQL Enums
 */
var PrivacyRegimeEnum;
(function (PrivacyRegimeEnum) {
    /** Unable to determine any applicable regimes */
    PrivacyRegimeEnum["Unknown"] = "Unknown";
    /** California Privacy Rights Act (and CCPA: California Consumer Privacy Act) */
    PrivacyRegimeEnum["CPRA"] = "CPRA";
    /** EU General Data Protection Regulation */
    PrivacyRegimeEnum["GDPR"] = "GDPR";
    /** Brazil Lei Geral de Proteção de Dados (General Personal Data Protection Law) */
    PrivacyRegimeEnum["LGPD"] = "LGPD";
    /** Virginia Consumer Data Protection Act */
    PrivacyRegimeEnum["CDPA"] = "CDPA";
    /** Colorado Privacy Act */
    PrivacyRegimeEnum["CPA"] = "CPA";
    /** Nevada Senate Bill 220 */
    PrivacyRegimeEnum["NEVADA_SB220"] = "NEVADA_SB220";
    /** Switzerland New Federal Act on Data Protection */
    PrivacyRegimeEnum["nFADP"] = "nFADP";
    /** US Do Not Sell/Share */
    PrivacyRegimeEnum["US_DNSS"] = "US_DNSS";
})(PrivacyRegimeEnum || (exports.PrivacyRegimeEnum = PrivacyRegimeEnum = {}));
//# sourceMappingURL=privacyRegime.js.map